import { render, staticRenderFns } from "./StudentPaymentSession.vue?vue&type=template&id=b18aeb04"
import script from "./StudentPaymentSession.vue?vue&type=script&lang=js"
export * from "./StudentPaymentSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports